import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { MetadataChangeset } from "@/shared/domain/metadataChangeset";

import { type Device } from "../Device";

interface UpdateDeviceRequest {
  metadata_changeset?: MetadataChangeset;
}

interface UpdateDeviceParams {
  deviceId: string;
  resourceOwnerId: string;
  updates: UpdateDeviceRequest;
}

export function useUpdateDevice() {
  const { devices } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<Device, Error, UpdateDeviceParams>({
    mutationFn: async ({ deviceId, resourceOwnerId, updates }) => {
      return devices.updateDevice(deviceId, updates, {
        resourceOwnerId,
      });
    },
    onSuccess: (updatedDevice, { deviceId }) => {
      // Invalidate and refetch device queries
      void queryClient.invalidateQueries({
        queryKey: ["devicesByOrg"],
      });

      // Update the specific device query cache
      queryClient.setQueryData(["device", deviceId], updatedDevice);
    },
  });
}
